/* LockToggleRenderer.js */

'use strict';

class LockToggleRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('lock-toggle-gl'); //TODO Setup the root Element
    this._rootElem.component = this._model;
    this._logger = this._model.logger;

    this._lockElem = document.createElement('toggle-icon-gl');
    this._lockElem.dataset.icon = 'common.lock';
    this._title = document.createElement('span');

    this._registerListeners();
  }
  /********************************************/
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /********************************************/
  _registerListeners() {
    this.model.on('UserClick', (this.render = this.render.bind(this)));
    this._rootElem.addEventListener('click', (this._toggleState = this._toggleState.bind(this)));
  }
  _unregisterListeners() {
    this.model.removeAllListeners('UserClick');
    this._rootElem.removeEventListener('click', this._toggleState);
  }
  _toggleState() {
    this.model.isLocked = !this.model.isLocked;
  }
  _renderState() {
    if (this._model.isLocked) {
      this._title.innerText = 'Edit';
      this._lockElem.setToggled(false);
    } else {
      this._title.innerText = 'Lock';
      this._lockElem.setToggled(true);
    }
    return Promise.resolve();
  }
  /*******************************************/
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /*******************************************/
  shutdown() {
    this._unregisterListeners();
    let promArr = [Promise.resolve()];

    return Promise.all(promArr).then(
      () => {
        this._lockElem.remove();
        this._lockElem = undefined;
        this._title.remove();
        this._title = undefined;
        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
      },
      (err) => {
        this._logger.warn(err, 'LockToggleRenderer.shutdown() error');
      }
    );
  }
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    if (!this._rootElem.hasChildNodes()) {
      this._rootElem.appendChild(this._lockElem);
      this._rootElem.appendChild(this._title);
    }
    return this._renderState();
  }
  get rootElement() {
    return this.getRootElement();
  }
  getRootElement() {
    return this._rootElem;
  }
  get model() {
    return this.getModel();
  }
  getModel() {
    return this._model;
  }
  /*******************************************/
  /* END COMPONENT RENDERER METHODS */
  /* START PRIVATE RENDER METHODS */
  /*******************************************/

  /*******************************************/
  /* END PRIVATE RENDER METHODS */
  /* START HANDLER METHODS */
  /*******************************************/

  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE API METHODS */
  /*******************************************/

  /*******************************************/
  /*  END PRIVATE API METHODS */
  /*******************************************/
}
module.exports = LockToggleRenderer;
